import Card from "./card";
import { Check } from "lucide-react";

const packages = [
  {
    name: "Basic Social Media",
    odd: false,
    features: [
      "2 platforms (Facebook & Instagram)",
      "12 posts/month (carousels, graphics, reels)",
      "Copywriting & captions",
      "Hashtag/keyword research",
      "Basic engagement & organic follower growth",
      "Profile optimization (bio, banners, highlights)",
      "Growth guarantee (1k followers): targeted followers included",
    ],
  },
  {
    name: "Premium Social Media",
    odd: true,
    features: [
      "4 platforms (Instagram, Facebook, X, LinkedIn)",
      "20 posts/month (reels, graphics, branded videos)",
      "Paid ad management + retargeting campaigns",
      "Advanced profile branding (custom banners, covers)",
      "Weekly detailed growth reports + calls",
      "Stronger follower (3k followers) and engagement guarantees",
    ],
  },
  {
    name: "Basic Digital Marketing",
    odd: false,
    features: [
      "2 platforms (Social + Website/SEO OR Social + Email)",
      "12 posts/month (as in Social Basic Package)",
      "1 photography + 1 video session",
      "1 SEO blog/article per month",
      "2 ad campaigns/month (excluding ad spend)",
      "Micro Influencer & UGC campaign management",
      "Monthly analytics + strategy call",
      "Basic community management",
    ],
  },
  {
    name: "Premium Digital Marketing",
    odd: true,
    features: [
      "Unlimited platforms (Social, SEO, PPC, Email, YouTube/TikTok, PR, Influencers)",
      "30 posts/month (carousels, reels, motion graphics, videos)",
      "3 photography/video sessions",
      "5 SEO blogs/articles per month",
      "Advanced community management & brand monitoring",
      "Paid ad management across Google, Meta, TikTok, LinkedIn",
      "Full-funnel systems (retargeting, upsells, cross-sells)",
      "Weekly reports + bi-weekly strategy calls",
    ],
  },
];

const PackagesSection = () => {
  return (
    <section className="py-20 bg-background" id="packages">
      <div className="mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 text-foreground">
            Our Service Packages
          </h2>
          <p className="text-center text-muted-foreground mb-6 text-lg">
            Choose the perfect package for your business needs
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {packages.map((pkg, index) => (
              <Card
                key={index}
                className={`flex flex-col gap-1 justify-between p-6 hover:shadow-xl transition-all duration-300 relative ${pkg.odd ? "bg-blue-900 text-white" : "bg-white text-foreground"}`}
              >
                <>
                  <h3 className="text-2xl font-bold mb-4 text-foreground flex items-center justify-center">
                    {pkg.name}
                  </h3>
                  <ul className="space-y-3 mb-6">
                    {pkg.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-start gap-2">
                        <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-muted-foreground">
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                </>
                <div className="flex justify-center">
                  <a href="#contact-form">
                    <button
                      className={`${!pkg.odd ? "bg-blue-900 text-white" : "bg-white text-blue-900"}  px-8 py-3 mx-auto mt-5 text-[1.1em] font-semibold rounded-full `}
                    >
                      Get Started
                    </button>
                  </a>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackagesSection;
